import { css, Global } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { ROUTES, useWindowLocation } from "shared";

const GlobalStyles = () => {
    const { blue200, blue400, white } = colors;

    const { pathname } = useWindowLocation();

    const isFirefox =
        typeof navigator !== "undefined" &&
        /firefox/i.test(navigator.userAgent);

    const checkIfToShowBodyScrollBar = (path: string) =>
        path.toLowerCase() === ROUTES.Login ? "unset" : "hidden";

    return (
        <Global
            styles={css({
                "*": {
                    ...(isFirefox && {
                        scrollbarColor: `${blue200} transparent`
                    }),

                    "&::-webkit-scrollbar": {
                        width: "18px",
                        height: "18px"
                    },

                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: blue200,
                        borderRadius: "100px",
                        border: `5px solid ${white}`,
                        minHeight: "60px"
                    },

                    "&::-webkit-scrollbar-thumb:hover": {
                        backgroundColor: blue400
                    }
                },

                html: {
                    height: "100%",
                    background: white
                },

                body: {
                    height: "100%",
                    margin: "0",
                    fontFamily: '"Inter", sans-serif',
                    overflowY: checkIfToShowBodyScrollBar(pathname),
                    overflowX: "hidden",

                    "header + main": {
                        width: "calc(100vw - 18px)"
                    },

                    "@media (max-width: 959px)": {
                        "header + main, #root > footer": {
                            width: "100%"
                        }
                    }
                },

                "#root": {
                    height: "100%",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column"
                },

                "main, .remaining-height": {
                    display: "flex",
                    flexDirection: "column",
                    flex: "1"
                },

                ".navigation-item": {
                    display: "flex",
                    alignItems: "center",
                    padding: "6px",
                    borderRadius: "4px",
                    overflowX: "hidden",
                    transition:
                        "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
                },

                "input[type='password']::-ms-reveal": {
                    display: "none"
                },

                "h1, h2, h3, h4, h5, h6": {
                    margin: "0",
                    fontWeight: "unset"
                },

                ul: {
                    margin: "0",
                    padding: "0"
                },

                li: {
                    listStyle: "none"
                },

                a: {
                    textDecoration: "none",
                    color: "inherit",
                    WebkitTapHighlightColor: "transparent"
                },

                button: {
                    fontFamily: '"Inter", sans-serif'
                }
            })}
        />
    );
};

export default GlobalStyles;
